import src from "IMAGE";
export default { src, width: 2276, height: 2500, blurWidth: 0, blurHeight: 0};
